/**
 * @desc 账号登录
 */
import { LoginResult, LoginPasswordForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type LoginOperationByPasswordParameter = LoginPasswordForm

const method = 'POST'
const url = '/auth/operation/login/password'

export const loginOperationByPasswordApi = (
  data?: LoginOperationByPasswordParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<LoginResult>({
    method,
    url,
    data,
    ...config
  })
}

loginOperationByPasswordApi.method = method
loginOperationByPasswordApi.url = url
